var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgReward(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.5H13.6562C13.875 4.125 14 3.71875 14 3.25C14 1.75 12.75 0.5 11.25 0.5C9.9375 0.5 9.09375 1.1875 8.03125 2.65625C6.9375 1.1875 6.09375 0.5 4.8125 0.5C3.28125 0.5 2.0625 1.75 2.0625 3.25C2.0625 3.71875 2.15625 4.125 2.375 4.5H1.5C0.65625 4.5 0 5.1875 0 6V10C0 10.2812 0.21875 10.5 0.5 10.5H1V13.875C1 14.7812 1.71875 15.5 2.625 15.5H13.3438C14.25 15.5 15 14.7812 15 13.875V10.5H15.5C15.75 10.5 16 10.2812 16 10V6C16 5.1875 15.3125 4.5 14.5 4.5ZM7.25 14H2.625C2.5625 14 2.5 13.9375 2.5 13.875V10.5H6V9H1.5V6H7.25V14ZM4.78125 4.5C4.09375 4.5 3.53125 3.96875 3.53125 3.25C3.53125 2.5625 4.09375 2 4.78125 2C5.46875 2 5.96875 2.25 7.4375 4.40625L7.5 4.5H4.78125ZM8.59375 4.40625C10.0625 2.25 10.5625 2 11.25 2C11.9375 2 12.5 2.5625 12.5 3.25C12.5 3.96875 11.9375 4.5 11.25 4.5H8.53125L8.59375 4.40625ZM14.5 9H10V10.5H13.5V13.875C13.5 13.9375 13.4375 14 13.3438 14H8.75V6H14.5V9Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgReward);
export default __webpack_public_path__ + "static/media/img_reward.26d6346a1ca90b70fcaddd162f86cdfe.svg";
export { ForwardRef as ReactComponent };